<template>
  <v-container fluid>
    <v-toolbar dark color="primary">
      <v-btn icon>
        <v-icon @click="$router.go(-1)">mdi-backspace</v-icon>
      </v-btn>
      <v-toolbar-title>Lesson Plan Book</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-select
        class="mt-6"
        v-model="course"
        :items="courses"
        item-text="course_name"
        item-value="course_id"
        label="Courses"
        dark
        dense
        return-object
        @change="getAvailablePlans(), getUnitsStandards()"
      ></v-select>
    </v-toolbar>

    <v-container v-if="course.course_id" fluid>
      <div class="text-center">
        <v-btn
        class="mb-3"
       
        color="secondary"
        @click="addNewPlan"
      >
        Add New Plan to
        {{ course.course_name }}</v-btn
      >
      </div>
      
      <v-card>
        <v-data-table
          :headers="lessonPlanHeaders"
          :items="availablePlansForReuse"
          :items-per-page="20"
          item-key="id"
          group-by="unit.objective"
          class="elevation-1"
          show-group-by
         
        >
          <template v-slot:[`group.header`]="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length">
              <v-btn
                @click="toggle"
                small
                icon
                :ref="group"
                :data-open="isOpen"
              >
                <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </v-btn>
              <span style="font-weight: bold"> {{ group.toUpperCase() }} </span>
            </td>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            <v-chip>{{ new Date(item.created_at).toLocaleDateString() }}</v-chip>
          </template>
          <template v-slot:[`item.unit`]="{ item }">
            <v-chip>{{ item.unit.objective }}</v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon @click="editExistingPlan(item)"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
            <v-btn icon @click="deletePlanId=item.id, deletePlanTitle=item.title, dialogDelete=true"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </template>
        </v-data-table>
      </v-card>
    </v-container>
     <v-dialog v-model="dialogDelete" width="600">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on"> </v-icon>
      </template>
      <v-card>
        <v-card-title>
          <v-toolbar dark color="red">
Delete Plan
          </v-toolbar>
        </v-card-title>
        <v-card-text>
       Plan title: {{  deletePlanTitle}}
        </v-card-text>
        
      
      <v-card-actions>
        <v-spacer />
         <v-btn @click="deletePlanId=null, dialogDelete=false"> Cancel
         </v-btn>
        <v-btn @click="removeExistingPlan(), dialogDelete=false">Delete</v-btn>
       
      </v-card-actions>
      </v-card>
     </v-dialog>


    <v-dialog v-model="dialogNewEditPlan" width="800" scrollable persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on"> </v-icon>
      </template>
      <v-card>
        <v-toolbar class="headline grey lighten-2">
          Add New Plan
          <v-spacer></v-spacer>
          <v-btn text @click="dialogNewEditPlan = false"> Cancel </v-btn>
          <v-btn color="primary" dark @click="savePlan()"> Save Plan </v-btn>
        </v-toolbar>

        <v-card-text class="mt-5">
          <v-row>
            <v-container fluid>
              <v-card outlined>
                <v-toolbar dark dense>Lesson Plan Header</v-toolbar>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="8" lg="8">
                      <v-text-field
                        autocomplete="off"
                        placeholder="Title"
                        v-model="editedLessonPlan.title"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" lg="4">
                      <v-select
                        v-model="editedLessonPlan.unit"
                        :items="units"
                        item-text="objective"
                        item-value="phaseRank"
                        label="Units"
                        return-object
                        clearable
                      >
                      </v-select>
                     
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" lg="12">
                      <v-text-field
                        autocomplete="off"
                        v-model="editedLessonPlan.essential_question"
                        placeholder="Essential Question/Lesson Objective"
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" lg="12">
                      <v-select
                        v-model="editedLessonPlan.standards"
                        :items="standards"
                        item-text="objective"
                        item-value="phaseRank"
                        return-object
                        multiple
                        label="Learning Standards"
                        dense
                      >
                        <template v-slot:selection="{ item, index }">
                          {{ index + 1 }}) {{ item.objective }}<br />
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-container>
          </v-row>
          <v-row>
            <v-container fluid>
              <v-card outlined>
                <v-toolbar dark dense>Lesson Plan Content</v-toolbar>

                <v-col
                  v-for="(content, id) in editedLessonPlan.contents"
                  :key="id"
                  cols="12"
                  md="12"
                  lg="12"
                >
                
                  <v-card class="mt-3" outlined>
                    <v-toolbar color="grey lighten-2" dense>
                      <v-combobox
                        v-model="content.type"
                        :items="contentOptions"
                        label="Content Type"
                        solo
                        dense
                        class="mb-n6"
                      ></v-combobox>
                      <v-spacer />
                      <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        
                      <v-icon
                        v-if="content.visible"
                        v-bind="attrs"
                          v-on="on"
                        @click="content.visible = false"
                        class="mr-5"
                      >
                        mdi-eye
                      </v-icon>
                      <v-icon
                        v-else
                        v-bind="attrs"
                          v-on="on"
                        @click="content.visible = true"
                        class="mr-5"
                      >
                        mdi-eye-off
                      </v-icon>
                      </template>
      <span>Visible to Students:{{content.visible}}</span>
    </v-tooltip>

                      <v-btn icon @click="deleteContent(id)">
                        <v-icon>mdi-delete</v-icon></v-btn
                      >
                    </v-toolbar>

                    <v-card-text class="pa-0">
                      <div class="mx-0 px-0">
                        <!-- Use the component in the right place of the template -->
                        <tiptap-vuetify
                          v-model="content.content"
                          :extensions="extensions"
                        />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                   v-if="editedLessonPlan.contents"
                    @click="addContent()"
                    color="blue-grey"
                    class="mx-auto white--text"
                    ><v-icon dark class="mx-3"> mdi-plus </v-icon>
                    Add {{editedLessonPlan.contents.length>0 ? "More": ""}} Content
                  </v-btn>
                  <v-spacer />
                </v-card-actions>
              </v-card>
            </v-container>
          </v-row>

          
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
export default {
  components: { TiptapVuetify },
  data: () => ({
    units: [],
    standards: [],
    courses: [],
    course: {},
    deletePlanId:null,
    deletePlanTitle:null,
    dialogNewEditPlan: false,
    dialogDelete: false,
    availablePlansForReuse: [],
    blakLessonPlan:
    {
      id : null,
      title : null,
      essential_question : null,
      author_user_id : null,
      contents:[],
      unit:{},
      standards:[],
    },
    editedLessonPlan: {},
    content: {
      type: "",
      visible: true,
      content: `
      <h1>My content </h1>
      <p>My content details </p>
    `,
    },
    contentOptions: [
      "Intro (Hook / Do Now)",
      "Teaching & Instruction",
      "Student Learning Activity ",
      "Graded / Ungraded work",
    ],
    lessonPlanHeaders: [
      
      { text: "Title", value: "title", groupable: false },
      { text: "Objective", value: "essential_question", groupable: false },
      { text: "Author", value: "author_full_name", groupable: false },
      { text: "Date Created", value: "created_at", groupable: false },
      { text: "Actions", value: "actions", sortable: false, groupable: false },
    ],
    // declare extensions you want to use
    extensions: [
      History,
      Blockquote,
      Link,
      Underline,
      Strike,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      [
        Heading,
        {
          options: {
            levels: [1, 2, 3],
          },
        },
      ],
      Bold,
      Code,
      HorizontalRule,
      Paragraph,
      HardBreak,
    ],
  }),

  methods: {
    getUnitsStandards(){
        this.$sisApi(
      "get",
      `my-schedule/course/${this.course.course_id}`
    )
      .then((response) => {
        this.units = response.data.units;
        this.standards = response.data.standards;
      })
      .catch((error) => {
        this.snackbar = true;
        this.snackbar_text = error.response.data.message;
      }); 
    },
    
    addNewPlan() {
    
      this.editedLessonPlan = {...this.blakLessonPlan}
      this.editedLessonPlan.contents = [...this.blakLessonPlan.contents]
      this.editedLessonPlan.unit = {...this.blakLessonPlan.unit}
      this.editedLessonPlan.standards = [...this.blakLessonPlan.standards]

      this.editedLessonPlan.course_id = this.course.course_id
      this.dialogNewEditPlan = true
    },
    editExistingPlan(item) {
      
      this.editedLessonPlan = {...item}
      this.editedLessonPlan.contents = [...item.contents]
      this.editedLessonPlan.unit = {...item.unit}
      this.editedLessonPlan.standards = [...item.standards]

      this.dialogNewEditPlan = true;
    },
    removeExistingPlan() {
      this.$sisApi("delete", `my-schedule/content/${this.deletePlanId}`)
        .then(() => {
         const index = this.availablePlansForReuse.findIndex(
            (plan) => plan.id === this.deletePlanId
          )
          this.availablePlansForReuse.splice(index, 1);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.snackbarMessage = error.response;
            this.snackbar = true;
          }
        });
    },

    savePlan() {
      if (this.editedLessonPlan.id === null) {
        this.$sisApi("post", `my-schedule/content`, this.editedLessonPlan)
          .then((response) => {
            this.availablePlansForReuse.push(response.data)
            this.dialogNewEditPlan = false;
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.snackbarMessage = error.response;
              this.snackbar = true;
             
            }
          });
      } else {
        this.$sisApi("put", `my-schedule/content`, this.editedLessonPlan)
          .then((response) => {
            console.log(response)
            const index = this.availablePlansForReuse.findIndex(
            (plan) => plan.id === this.editedLessonPlan.id
          )
         
          this.availablePlansForReuse.splice(index, 1, response.data);
        
            this.dialogNewEditPlan = false;
            // let index = this.availablePlansForReuse.find(p => p.id == response.id)
            // this.availablePlansForReuse[index] = response.data;
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.snackbarMessage = error.response;
              this.snackbar = true;
              console.log(error.response);
            }
          });
      }
    },
    

addContent(){
   this.editedLessonPlan.contents.push({...this.content});
},

    deleteContent(id) {
      this.editedLessonPlan.contents.splice(id, 1);
    },
    getAvailablePlans() {
      this.$sisApi("get", `my-schedule/contents/${this.course.course_id}`).then(
        (response) => {
          
          this.availablePlansForReuse = response.data.filter(
            (plan) => plan.master_id == null
          );
        }
      );
    },
  },
  mounted() {
    this.$sisApi("get", "my-schedule/course-sections")
      .then((response) => {
        this.courses = response.data;
        /*    this.sections = response.data.map(item => {
          item.name = `${item.course_name} Section ${item.section_name}`; 
          return item;
        }); */
      })
      .catch((error) => {
        console.log(error);
      });

    /* this.$sisApi("get", "course-content/my-by-course", {
      course_id: this.$store.state.course.course_id,
    }).then((response) => {
   
      this.availablePlansForReuse = response.data.filter(
        (plan) => plan.master_id == null
      );
    });

    this.$sisApi(
      "get",
      `courses/my-course/${this.$store.state.course.course_id}`
    )
      .then((response) => {
        
        this.units = response.data.units;
        this.standards = response.data.standards;
      })
      .catch((error) => {
       
        this.snackbar = true;
        this.snackbar_text = error.response.data.message;
      }); */
  },
};
</script>
